<div class="modal-body width-600">
  <h5 class="modal-header">
      {{getResource('Edit',{name:uiModel.dokName})}}
  </h5>
  <div class="layout-auto-auto">
    <div>
      <exg-input [(ngModel)]="uiModel.dokName" [caption]="getResource('Name')"
                    type="text" #nodeText name="apiName">
      </exg-input>
    </div>
    <div class="grid cols-2">
      <exg-select #t name="DokTypeSelect"
                  caption="{{enumSvc.getFieldCaption('Dokument','dok_enmIdent_DokTyp')}}"
                  [ngModel]="uiSelectDocumentTypeIndex"
                  (ngModelChange)="setDocumentType($event); t.closed=true"
                  [list]="enumSvc.getEnumerationList('DokTyp')"
                  listdisplay="enmText">
      </exg-select>
      <exg-checkbox class="md-check-reverse nocaption" [(ngModel)]="uiModel.dokTrackingPortalShare"
                    caption="Freigabe Trackingportal" type="switch"
                    *ngIf="userType===2">
      </exg-checkbox>
    </div>
    <div>
      <exg-textarea [(ngModel)]="uiModel.dokBeschreibung" [caption]="getTranslation('Beschreibung')"
                    type="text" #nodeText name="apiDescription">
      </exg-textarea>
    </div>
    <div>
      <form #EigForm="ngForm">
        <ng-container *ngFor="let prop of dokEigenschaftTypList">
          <exg-input *ngIf="prop.det_enmIdent_DeigFormat === 1" [(ngModel)]="dokEigenschaftHelper[prop.detIdent]"
                     type="text" [name]="prop.detName" hintText="*"
                     [caption]="prop.detName" [required]="prop.detRequired"></exg-input>
          <exg-input *ngIf="prop.det_enmIdent_DeigFormat === 2" [(ngModel)]="dokEigenschaftHelper[prop.detIdent]"
                     type="date" [name]="prop.detName"
                     [caption]="prop.detName" [required]="prop.detRequired"></exg-input>
        </ng-container>
      </form>
    </div>
  </div>
  <div class="spawn-modal-actions">
    <button (click)="close()" class="md-btn">
      {{getResource('Cancel')}}
    </button>
    <button (click)="save()" [disabled]="EigForm.invalid" class="md-btn">
      {{getResource('Save')}}
    </button>
  </div>
</div>
